export function NotFoundPage() {
  return (
    <div className="typ-headline-2xl text-neutral-40 flex h-[60vh] w-full select-none items-center justify-center text-8xl">
      404
    </div>
  );
}

export default NotFoundPage;
